module.exports = __webpack_public_path__ + "img/file-doc.097c2f5a.png";